import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import { type EventInput, useEventsClient } from './provider.tsx'

type Ok = { ok: true }

export function useEmitEvent(options?: UseMutationOptions<Ok, Error, EventInput>) {
  const { emitEvent } = useEventsClient()

  const { mutateAsync } = useMutation<Ok, Error, EventInput>({
    mutationKey: ['event:emit'],
    mutationFn: body => emitEvent(body),
    ...options,
  })

  return mutateAsync
}
